// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"72c7556c","732":"941b601c","977":"bc97a44f"}[chunkId] + ".chunk.js");